(function () {
  function initProductCards(scope) {
    var cards = (scope || document).querySelectorAll('[data-bil-product-card]');

    cards.forEach(function (card) {
      if (card.dataset.bilProductReady === 'true') return;

      var variantInput = card.querySelector('[data-bil-variant-select]');
      var price = card.querySelector('[data-bil-price]');
      var compare = card.querySelector('[data-bil-compare]');
      var button = card.querySelector('[data-bil-add-button]');
      var buttonLabel = card.querySelector('[data-bil-add-button-label]');

      if (!variantInput || !button || !buttonLabel) return;

      function updateCard() {
        var option = variantInput.options ? variantInput.options[variantInput.selectedIndex] : null;
        if (!option) return;

        var available = option.dataset.available === 'true';
        var addLabel = button.dataset.addLabel || 'ADD TO CART';
        var soldOutLabel = button.dataset.soldOutLabel || 'SOLD OUT';

        if (price && option.dataset.price) {
          price.textContent = option.dataset.price;
        }

        if (compare) {
          if (option.dataset.compare) {
            compare.textContent = option.dataset.compare;
            compare.hidden = false;
          } else {
            compare.textContent = '';
            compare.hidden = true;
          }
        }

        button.disabled = !available;
        buttonLabel.textContent = available ? addLabel : soldOutLabel;
      }

      variantInput.addEventListener('change', updateCard);
      updateCard();
      card.dataset.bilProductReady = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductCards(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initProductCards(event.target);
  });
})();
